import React, { MouseEventHandler } from 'react';

type props = {
  className: string;
  id?: string;
  style?: React.CSSProperties;
  onClick?: MouseEventHandler<HTMLElement>;
};

const Icons = ({ className, style = {}, id = '', onClick = () => {} }: props) => {
  return <i className={className} id={id} style={style} onClick={onClick}></i>;
};

export default Icons;
